import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ShieldAlert, ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

/**
 * Safe mobile fallback shown when a support worker attempts an action on a
 * participant/resource they are not assigned to (HTTP 403). Replaces raw
 * error states with a clear, non-technical message.
 */
export const MobileAccessDenied = ({
  title = 'Access not allowed',
  message = 'You are not assigned to this participant, so you cannot record this here. Please contact your coordinator if you believe this is a mistake.',
  onBack,
}) => {
  const navigate = useNavigate();
  return (
    <div
      className="min-h-screen bg-background flex flex-col items-center justify-center px-6 text-center"
      data-testid="mobile-access-denied"
    >
      <div className="h-20 w-20 rounded-full bg-amber-500/10 flex items-center justify-center mb-6">
        <ShieldAlert className="h-10 w-10 text-amber-500" />
      </div>
      <h1 className="text-xl font-semibold mb-2" data-testid="access-denied-title">{title}</h1>
      <p className="text-sm text-muted-foreground max-w-sm mb-8" data-testid="access-denied-message">
        {message}
      </p>
      <Button
        onClick={onBack || (() => navigate('/mobile'))}
        className="gap-2"
        data-testid="access-denied-back-btn"
      >
        <ArrowLeft className="h-4 w-4" />
        Back to home
      </Button>
    </div>
  );
};

export default MobileAccessDenied;
